import { useState, useCallback } from "react";
import { apiCore } from "../api/apiCore";
import * as url from "../api/urls";

export const useRecoverPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMsg, setSuccessMsg] = useState<string | null>(null);

  const recover = useCallback(async (data: { email: string }) => {
    try {
      setLoading(true);
      setError(null);
      setSuccessMsg(null);

      // chamada real
      const result = await apiCore(url.USER_CHANGE_PASSWORD, {
        method: "POST",
        body: data,
      });

      setSuccessMsg("Password reset instructions sent to your email.");
      return result;
    } catch (err: any) {
      setError(err?.toString() ?? "Error requesting password reset.");
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    successMsg,
    recover,
  };
};
